(function () {
    'use strict';

    angular
        .module('backApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent,
            availableLanguages:availableLanguages
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            // var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');
            var language = "zh-cn";

            deferred.resolve(language);

            return deferred.promise;
        }

        function availableLanguages(){
            var languages = [
                {key: "简体中文", value: "zh-cn"},
                {key: "英文", value: "en"},
                // {key: "日文", value: "ja"},
                // {key: "韩文", value: "ko"},
                // {key: "德语", value: "Deutsch"},
            ];
            return languages
        }
    }
})();
